exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appInfo{font-family:Arial!important}.sale{width:98%;height:18px;background-color:#fff}.buy{width:200px;height:25px}", ""]);

// exports
